export default {
  apiKey: "AIzaSyCygnZclntq16cbkeIqW1R7sYZ2U44Y-LI",
  authDomain: "jad-green-thumb.firebaseapp.com",
  databaseURL: "https://jad-green-thumb.firebaseio.com",
  projectId: "jad-green-thumb",
  storageBucket: "jad-green-thumb.appspot.com",
  messagingSenderId: "227459594710",
  appId: "1:227459594710:web:d92872da43dc4290874c77",
  measurementId: "G-QLSS6L90JQ"
}